import React from 'react';

import { UserCheckRegularIcon } from '../../shared/icons/icons';

import './verified-reviews-message.scss';

export default function VerifiedReviewsMessage() {
  return (
    <>
      <UserCheckRegularIcon styleName="icon" /> All reviews are verified
      customer purchases.
    </>
  );
}
